import { unwrapNonNull, unwrapNonNullTypeName } from "../util"
import React from "react"


export function resolveByType(type)
{
    const unwrapped = unwrapNonNullTypeName(type)
    switch (unwrapped)
    {
        case "Boolean":
            return (ctx, fd, value) => {
                const { name, description } = fd
                return (
                    <label>
                        <input
                            type="checkbox"
                            name={ name }
                            title={ description }
                            checked={ value }
                            onChange={ ev => ctx.setValue(fd, ev.target.checked) }
                        />
                        { " " + name }
                    </label>
                )
            }
        case "Int":
            return (ctx, fd, value) => {
                const { name, description } = fd
                return (
                    <label>
                        <input
                            type="text"
                            name={ name }
                            title={ description }
                            value={ value }
                            onChange={ ev => ctx.setValue(fd, ev.target.value) }
                        />
                        { " " + name }
                    </label>
                )
            }
        case "String":
            return (ctx, fd, value) => {
                const { name, description } = fd
                return (
                    <label>
                        <input
                            type="text"
                            name={ name }
                            title={ description }
                            value={ value }
                            onChange={ ev => ctx.setValue(fd, ev.target.value) }
                        />
                        { " " + name }
                    </label>
                )
            }
        default:
            return (ctx, fd, value) => false
    }
}


/**
 * Renders a String field as textarea. Must be used via registerRenderer
 *
 * @param {FormContext} ctx     Form context
 * @param {object} fd           GraphQL field definition
 * @param {String} value        current value
 * @param {number} rows         rows attribute for the textarea
 * @param {number} cols         cols attribute for the textarea

 * @return {JSX.Element}    rendered form field
 */
export function renderTextArea(ctx, fd, value, {rows = 5, cols = 40} = {})
{
    const { name, description } = fd
    const type = unwrapNonNull(fd.type).name
    return (
        <label>
            <textarea
                rows={ rows }
                cols={ cols }
                name={ name }
                title={ description }
                value={ value }
                onChange={ ev => ctx.setValue(fd, ev.target.value) }
            />
            { " " + name }
        </label>
    )
}
